import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=166da22c&scoped=true&"
import script from "./BaseBadge.vue?vue&type=script&lang=ts&"
export * from "./BaseBadge.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=166da22c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166da22c",
  null
  
)

export default component.exports